import { Mesh } from 'three';

export const isMesh = (object: any): object is Mesh => object?.isMesh;

export default isMesh;
